import Core from '../../core/render';
import Utils from '../../core/utils';
import './wio.scss';

class CoreCustom extends Core {
  customCall = (campaignId) => {
    if (campaignId === 63018361) {
      const li = document.createElement('li');
      li.setAttribute('class', 'level-0 active_on_module-prestablog-blog');
      li.innerHTML = '<a href="#ciblertrigger" style="background-color: #382F2D; color: white;">JEU CONCOURS</a>';

      document.querySelector('#maxi_menu').appendChild(li);
    }
  };

  crossSellCustomAction = (productId, _code, callback) => {
    fetch("https://centifoliabio.fr/fr/panier", {
      "headers": {
        "accept": "application/json, text/javascript, */*; q=0.01",
        "accept-language": "fr-FR,fr;q=0.9,en;q=0.8,en-US;q=0.7",
        "cache-control": "no-cache",
        "content-type": "application/x-www-form-urlencoded; charset=UTF-8"
      },
      "body": `token=${window.static_token}&id_product=${productId}&id_customization=0&qty=1&add=1&action=update`,
      "method": "POST",
      "mode": "cors",
      "credentials": "include"
    }).then(r => r.text()).then(callback);
  }
}

window.WIOCONFIG.callRender = (customerId) => {
  if (window.WIORENDER) return;

  window.WIORENDER = new CoreCustom(customerId || window.WIO.customerId);
};

if (window.WIO && window.WIO.trackingComplete) {
  window.WIOCONFIG.callRender();
}
